"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteInvestmentAccountActionWatcher = exports.batchInvestmentAccountsActionWatcher = exports.updateInvestmentAccountActionWatcher = exports.createInvestmentAccountActionWatcher = exports.getInvestmentAccountsActionWatcher = void 0;
/*
 * ACCOUNT STORE SAGAS
 *
 * These routines listen for request actions, and satisfies them.  These are asynchronous routines, and upon
 * completion will dispatch a new action with the results
 *
 *
 */
const effects_1 = require("redux-saga/effects");
const core_1 = require("companion-app-components/flux/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const actions = __importStar(require("./actions"));
const transformers = __importStar(require("./transformers"));
// ===============================================================================================
// SAGAS functions for accounts.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.  Data is returned via ACTIONS, however, these can be
// split out (and should be) to be fully functional and JS shareable API callers via Axios and
// simply return an object in a provided callback, which can then choose to call the actions
//
// =================================================================================================
// Investment Account Watchers
// =================================================================================================
const mkResourceConfigInvestmentAccounts = (successAction, failureAction) => core_1.resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investment-account',
    resourceBaseUrl: '/q17/accounts',
    getLastSyncDate: () => null,
    transformResponseToResources: transformers.transformResponseToInvestmentAccounts,
    transformResourceToRequestData: transformers.transformInvestmentAccountToQ17RequestData,
    transformResourcesToRequestData: transformers.transformInvestmentAccountsToQ17RequestData,
    successAction,
    failureAction,
});
function* getInvestmentAccountsActionWatcher() {
    // using a vanilla saga pattern so we only process a single get request
    //   - takeEvery would process every request
    //   - takeLatest would cancel any current request and start request again
    while (true) {
        const action = yield (0, effects_1.take)(actions.getInvestmentAccounts);
        const resourceConfig = mkResourceConfigInvestmentAccounts(actions.getInvestmentAccountsSuccess, actions.getInvestmentAccountsFailure);
        yield (0, effects_1.call)((core_1.resourceSagaUtils.qcsSyncGetResources), resourceConfig, action);
    }
}
exports.getInvestmentAccountsActionWatcher = getInvestmentAccountsActionWatcher;
function* createInvestmentAccountActionWatcher() {
    const resourceConfig = mkResourceConfigInvestmentAccounts(actions.createInvestmentAccountSuccess, actions.createInvestmentAccountFailure);
    yield (0, effects_1.takeEvery)(actions.createInvestmentAccount, core_1.resourceSagaUtils.qcsSyncCreateResource, resourceConfig);
}
exports.createInvestmentAccountActionWatcher = createInvestmentAccountActionWatcher;
function* updateInvestmentAccountActionWatcher() {
    const resourceConfig = mkResourceConfigInvestmentAccounts(actions.updateInvestmentAccountSuccess, actions.updateInvestmentAccountFailure);
    yield (0, effects_1.takeEvery)(actions.updateInvestmentAccount, core_1.resourceSagaUtils.qcsSyncUpdateResource, resourceConfig);
}
exports.updateInvestmentAccountActionWatcher = updateInvestmentAccountActionWatcher;
function* batchInvestmentAccountsActionWatcher() {
    const resourceConfig = mkResourceConfigInvestmentAccounts(actions.batchInvestmentAccountsSuccess, actions.batchInvestmentAccountsFailure);
    yield (0, effects_1.takeEvery)(actions.batchInvestmentAccounts, core_1.resourceSagaUtils.qcsSyncUpdateResources, resourceConfig);
}
exports.batchInvestmentAccountsActionWatcher = batchInvestmentAccountsActionWatcher;
function* deleteInvestmentAccountActionWatcher() {
    const resourceConfig = mkResourceConfigInvestmentAccounts(actions.deleteInvestmentAccountSuccess, actions.deleteInvestmentAccountFailure);
    yield (0, effects_1.takeEvery)(actions.deleteInvestmentAccount, core_1.resourceSagaUtils.qcsSyncDeleteResource, resourceConfig);
}
exports.deleteInvestmentAccountActionWatcher = deleteInvestmentAccountActionWatcher;
function* createInvestmentAccountSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.createInvestmentAccountSuccess, function* createInvestmentAccountSuccess({ payload }) {
        yield (0, effects_1.put)(accounts_1.accountsActions.applyAccountsChanges([payload], { context: 'createInvestmentAccountSuccess' }));
    });
}
function* updateInvestmentAccountSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.updateInvestmentAccountSuccess, function* updateInvestmentAccountSuccess({ payload }) {
        yield (0, effects_1.put)(accounts_1.accountsActions.applyAccountsChanges([payload], { context: 'updateInvestmentAccountSuccess' }));
    });
}
function* deleteInvestmentAccountSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.deleteInvestmentAccountSuccess, function* deleteInvestmentAccountSuccess({ payload }) {
        yield (0, effects_1.put)(accounts_1.accountsActions.applyAccountsChanges([payload], { context: 'deleteInvestmentAccountSuccess' }));
    });
}
function* batchInvestmentAccountsSuccessActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.batchInvestmentAccountsSuccess, function* batchInvestmentAccountsSuccess({ payload }) {
        yield (0, effects_1.put)(accounts_1.accountsActions.applyAccountsChanges(payload, { context: 'batchInvestmentAccountsSuccess' }));
    });
}
// =================================================================================================
// Exports
// =================================================================================================
exports.default = [
    ...accounts_1.accountsSagas,
    getInvestmentAccountsActionWatcher,
    createInvestmentAccountActionWatcher,
    updateInvestmentAccountActionWatcher,
    batchInvestmentAccountsActionWatcher,
    deleteInvestmentAccountActionWatcher,
    createInvestmentAccountSuccessActionWatcher,
    updateInvestmentAccountSuccessActionWatcher,
    deleteInvestmentAccountSuccessActionWatcher,
    batchInvestmentAccountsSuccessActionWatcher,
];
